import { render, staticRenderFns } from "./AlertConfirm.vue?vue&type=template&id=c4cf1c84&"
import script from "./AlertConfirm.vue?vue&type=script&lang=js&"
export * from "./AlertConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports